import * as React from "react";
import { cn } from "@/utils/cn";
import { Slot } from "@radix-ui/react-slot";
import styles from "./Button.module.css";

export type ButtonVariant =
  | "default"
  | "primary"
  | "secondary"
  | "outline"
  | "destructive"
  | "ghost"
  | "link";

export type ButtonSize =
  | "default"
  | "small"
  | "large"
  | "extra-small"
  | "icon"
  | "icon-small"
  | "icon-large";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  asChild?: boolean;
  variant?: ButtonVariant;
  size?: ButtonSize;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      variant = "default",
      size = "default",
      asChild = false,
      ...props
    },
    ref,
  ) => {
    const Comp = asChild ? Slot : "button";
    const variantString = variant + "-var";
    const sizeString = size + "-size";

    return (
      <Comp
        ref={ref}
        className={cn(
          styles.button,
          styles[variantString],
          styles[sizeString],
          className,
        )}
        {...props}
      />
    );
  },
);

export { Button, styles as ButtonStyles };
